
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/snapchat",
      function () {
        return require("private-next-pages/snapchat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/snapchat"])
      });
    }
  